module.exports = __webpack_public_path__ + "../resources/img/ic_line_check.4c869b58.svg";